import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../../constants/common'
import i18n from '../../../i18n'
import { PHONE_MAX_LENGTH, PHONE_MIN_LENGTH } from '../Phone.constants'

export function getPhoneSelectFieldValidValue(value) {
  return value
}

export function getPhoneSelectFormikFieldValidator({
  max = PHONE_MAX_LENGTH,
  maxError = 'Error.CommonPhoneInputErrorMaxLengthKey',
  min = PHONE_MIN_LENGTH,
  minError = 'Error.CommonPhoneInputErrorMinLengthKey',
} = EMPTY_OBJECT) {
  return Yup.string()
    .min(
      min,
      i18n.t(minError, {
        count: min,
      })
    )
    .max(
      max,
      i18n.t(maxError, {
        count: max,
      })
    )
}
